import useConfiguration from '@store/hooks/useConfiguration';
import { useTranslation } from 'react-i18next';

import Line from './Line';
import type { ILineItem, OnUpdateLine } from './types';

interface IProps {
  onUpdate: OnUpdateLine;
  lines: ILineItem[];
}

export default function Lines({ onUpdate, lines }: IProps) {
  const { t } = useTranslation();
  const config = useConfiguration();

  if (lines.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <div>
          <span className="text-gray-600">{t('BasketIsEmpty')}</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="basket-line header">
        <div className="column image"></div>
        <div className="column name">{t('ProductName')}</div>
        <div className="column stock">{t('Availability')}</div>
        <div className="column code">{t('ProductCode')}</div>
        <div className="column unit-count">
          <span className="w-full text-right">{t('UnitCount')}</span>
        </div>
        <div className="column unit-price">
          <span className="w-full text-right">
            {t(config.useBeforeVat ? 'UnitPriceBeforeVat' : 'UnitPriceAfterVat')}
          </span>
        </div>
        <div className="column total-price">
          <span className="w-full text-right">
            {t(config.useBeforeVat ? 'LinePriceBeforeVat' : 'LinePriceAfterVat')}
          </span>
        </div>
        <div className="column delete"></div>
      </div>
      {lines.map(line => (
        <Line key={line.lineId} onUpdate={onUpdate} {...line} />
      ))}
    </div>
  );
}
